import './App.less';
import MainComponent from '../views/main/index.vue';
export default {
  name: 'app',
  components: {
    MainComponent
  }
};